/**
 * Humanize a backend status/lifecycle code for display.
 *
 * Product tables must never show raw codes ("in_progress", "ready_for_generation").
 * Variant/colour logic still keys off the raw code; only the visible label is
 * humanized here so mock and live rows read identically.
 */
export function humanizeStatus(value: string | null | undefined): string {
  if (value == null) return "Unknown";
  const trimmed = String(value).trim();
  if (!trimmed) return "Unknown";
  return trimmed
    .replace(/[._-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
